"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coloredShadow = exports.btnLink = exports.mrAuto = exports.mlAuto = exports.sectionDescription = exports.sectionDark = exports.section = exports.mainRaised = exports.main = exports.cardSubtitle = exports.cardLink = exports.description = exports.cardTitle = exports.title = exports.defaultBoxShadow = exports.cardHeader = exports.cardActions = exports.roseCardHeader = exports.primaryCardHeader = exports.infoCardHeader = exports.dangerCardHeader = exports.successCardHeader = exports.warningCardHeader = exports.roseBoxShadow = exports.dangerBoxShadow = exports.warningBoxShadow = exports.successBoxShadow = exports.infoBoxShadow = exports.primaryBoxShadow = exports.infoColor = exports.successColor = exports.warningColor = exports.primaryColor = exports.defaultFont = exports.card = exports.boxShadow = exports.containerFluid = exports.container = exports.transition = exports.drawerWidth = void 0;
const colors_1 = require("./colors");
const drawerWidth = 260;
exports.drawerWidth = drawerWidth;
const transition = {
    transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
};
exports.transition = transition;
const isIE = !!document.documentMode;
const containerIE = isIE
    ? {
        '@media (min-width: 576px)': {
            width: '540px'
        },
        '@media (min-width: 768px)': {
            width: '720px'
        },
        '@media (min-width: 992px)': {
            width: '960px'
        },
        '@media (min-width: 1200px)': {
            width: '1140px'
        }
    }
    : {};
const containerFluid = {
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%'
};
exports.containerFluid = containerFluid;
const container = Object.assign(Object.assign(Object.assign({}, containerFluid), containerIE), { '@media (min-width: 576px)': {
        maxWidth: '540px'
    }, '@media (min-width: 768px)': {
        maxWidth: '720px'
    }, '@media (min-width: 992px)': {
        maxWidth: '960px'
    }, '@media (min-width: 1200px)': {
        maxWidth: '1140px'
    } });
exports.container = container;
const boxShadow = {
    boxShadow: '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
};
exports.boxShadow = boxShadow;
const card = {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '3px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff'
};
exports.card = card;
const defaultFont = {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    lineHeight: '1.5em'
};
exports.defaultFont = defaultFont;
const primaryColor = colors_1.default.themeColors.primaryColor.hex();
exports.primaryColor = primaryColor;
const warningColor = colors_1.default.themeColors.warningColor.hex();
exports.warningColor = warningColor;
const successColor = colors_1.default.themeColors.successColor.hex();
exports.successColor = successColor;
const infoColor = colors_1.default.themeColors.infoColor.hex();
exports.infoColor = infoColor;
const primaryBoxShadow = {
    boxShadow: `0 12px 20px -10px ${colors_1.default.themeColors.primaryColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${colors_1.default.themeColors.primaryColor.alpha(0.2).rgb()}`
};
exports.primaryBoxShadow = primaryBoxShadow;
const infoBoxShadow = {
    boxShadow: `0 12px 20px -10px ${colors_1.default.themeColors.infoColor
        .alpha(0.28)
        .rgb()}, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px ${colors_1.default.themeColors.infoColor.alpha(0.2).rgb()}`
};
exports.infoBoxShadow = infoBoxShadow;
const successBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(31, 198, 150, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(31, 198, 150, 0.2)`
};
exports.successBoxShadow = successBoxShadow;
const warningBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)`
};
exports.warningBoxShadow = warningBoxShadow;
const dangerBoxShadow = {
    boxShadow: `0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)`
};
exports.dangerBoxShadow = dangerBoxShadow;
const roseBoxShadow = {
    boxShadow: `0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)`
};
exports.roseBoxShadow = roseBoxShadow;
const warningCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ffa726, #fb8c00)` }, warningBoxShadow);
exports.warningCardHeader = warningCardHeader;
const successCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #66bb6a, #43a047)` }, successBoxShadow);
exports.successCardHeader = successCardHeader;
const dangerCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ef5350, #e53935)` }, dangerBoxShadow);
exports.dangerCardHeader = dangerCardHeader;
const infoCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #26c6da, #00acc1)` }, infoBoxShadow);
exports.infoCardHeader = infoCardHeader;
const primaryCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ab47bc, #8e24aa)` }, primaryBoxShadow);
exports.primaryCardHeader = primaryCardHeader;
const roseCardHeader = Object.assign({ color: '#fff', background: `linear-gradient(60deg, #ec407a, #d81b60)` }, roseBoxShadow);
exports.roseCardHeader = roseCardHeader;
const cardActions = Object.assign({ margin: '0 20px 10px', paddingTop: '10px', borderTop: '1px solid #eeeeee', height: 'auto' }, defaultFont);
exports.cardActions = cardActions;
const cardHeader = {
    margin: '-30px 15px 0',
    borderRadius: '3px',
    padding: '15px'
};
exports.cardHeader = cardHeader;
const defaultBoxShadow = {
    border: '0',
    borderRadius: '3px',
    boxShadow: '0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    padding: '10px 0',
    transition: 'all 150ms ease 0s'
};
exports.defaultBoxShadow = defaultBoxShadow;
const title = {
    color: colors_1.default.themeColors.infoColor.hex(),
    textDecoration: 'none',
    fontWeight: '700',
    marginTop: '30px',
    marginBottom: '25px',
    minHeight: '32px',
    fontFamily: '"Open Sans", sans-serif'
};
exports.title = title;
const cardTitle = {
    '&, & a': Object.assign(Object.assign({}, title), { marginTop: '.625rem', marginBottom: '0.75rem', minHeight: 'auto' })
};
exports.cardTitle = cardTitle;
const cardLink = {
    '& + $cardLink': {
        marginLeft: '1.25rem'
    }
};
exports.cardLink = cardLink;
const cardSubtitle = {
    marginBottom: '0',
    marginTop: '-.375rem'
};
exports.cardSubtitle = cardSubtitle;
const main = {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3'
};
exports.main = main;
const mainRaised = {
    '@media (max-width: 576px)': {
        marginTop: '-30px'
    },
    '@media (max-width: 830px)': {
        marginLeft: '10px',
        marginRight: '10px'
    },
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
};
exports.mainRaised = mainRaised;
const section = {
    backgroundPosition: '50%',
    backgroundSize: 'cover'
};
exports.section = section;
const sectionDark = {
    backgroundColor: '#343434',
    background: 'radial-gradient(ellipse at center,#585858 0,#232323 100%)'
};
exports.sectionDark = sectionDark;
const sectionDescription = {
    marginTop: '130px'
};
exports.sectionDescription = sectionDescription;
const description = {
    color: '#999'
};
exports.description = description;
const mlAuto = {
    marginLeft: 'auto'
};
exports.mlAuto = mlAuto;
const mrAuto = {
    marginRight: 'auto'
};
exports.mrAuto = mrAuto;
const btnLink = {
    backgroundColor: 'transparent',
    boxShdow: 'none',
    marginTop: '5px',
    marginBottom: '5px'
};
exports.btnLink = btnLink;
const coloredShadow = {
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        display: 'none !important'
    },
    transform: 'scale(0.94)',
    top: '12px',
    filter: 'blur(12px)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    zIndex: '-1',
    transition: 'opacity .45s',
    opacity: 0
};
exports.coloredShadow = coloredShadow;
//# sourceMappingURL=material-kit-pro-react.js.map